<category-component></category-component>
<div class="promotin-all" >
    <div class="promotion-heading">Promotions</div>
    <div class="row" *ngIf="promotions.length > 0 && componentLoaded">
        <div *ngFor="let promotion of promotions; let i = index" class="col-md-6 margin-cus">
            <img class="w-100 promotion-img" src="{{ promotion.image}}" alt="" (click)="viewPromotionsProducts('promotion/product/listing/',promotion.rule_id)" *ngIf="promotion?.is_selection_product == 1 && promotion?.is_promotion_applied == 0">
            <img class="w-100 promotion-img" src="{{ promotion.image}}" alt="" *ngIf="promotion?.is_selection_product == 0 || (promotion?.is_selection_product == 1 && promotion?.is_promotion_applied == 1)" (click)="viewPromotionsProducts('promotion/product/listing/',promotion.rule_id)">
            <div class="button-bar">
                <button class="add-deal  view-product-full" (click)="viewPromotionsProducts('promotion/product/listing/',promotion.rule_id)" *ngIf="promotion?.is_selection_product == 1"><a class="text-dark" href="javascript:void(0);" (click)="viewPromotionsProducts('promotion/product/listing/',promotion.rule_id)">View Deal</a></button>
                <button class="view-product" *ngIf="promotion?.is_selection_product == 0" (click)="viewPromotionsProducts('promotion/product/listing/',promotion.rule_id)"><a class="text-dark" href="javascript:void(0);" (click)="viewPromotionsProducts('promotion/product/listing/',promotion.rule_id)">View Products</a></button>
                <button class="add-deal" *ngIf="promotion?.is_selection_product == 0 && promotion?.is_promotion_applied == 0" (click)="addDeal(promotion.rule_id)">Add Deal</button>
                <button class="add-deal deal-applied " *ngIf="(promotion?.is_selection_product == 0 && promotion?.is_promotion_applied == 1) || (promotion?.is_selection_product == 1 && promotion?.is_promotion_applied == 1)">
          <img class="deal-button-image" src="../../../../assets/images/deal.svg" alt="">
          Deal Added
          <span *ngIf="promotion?.is_selection_product == 1 && promotion?.is_promotion_applied == 1">{{promotion?.promotion_applied_count}}</span>
      </button>

    <ngx-number-spinner id="spinerbtn_{{promotion.rule_id}}" class="spinner number-custom" 
    [value]="promotion?.promotion_applied_count" [min]="0"
        (change)="onChangePromotionCount(promotion,$event,removeFreePdtTemplate,i)"
        *ngIf="promotion?.is_selection_product == 0 && promotion?.is_promotion_applied == 1">
    </ngx-number-spinner>

            </div>
        </div>
    </div>
    <div class="no-listing" *ngIf="promotions.length == 0 && componentLoaded">
        <img src="../../assets/images/no-promotion.svg" alt="">
    </div>
    <div class="no-listing" *ngIf="!componentLoaded">
        <div class="col-12">
            <div class="no-result-content text-center text-dark">
                <img src="../../assets/images/hourglass-shb.svg" alt="no-result">
                <p>Loading...</p>
            </div>
        </div>
    </div>
</div>

<ng-template #removeFreePdtTemplate>
    <div class="modal-header border-0 pb-2">
        <h4 class="modal-title">Remove Deal</h4>
        <button type="button" class="close  " aria-label="Close" (click)="onPromotionRemovalCancel(modalService.config.initialState)">
        <span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <g fill="none" fill-rule="evenodd">
              <g stroke="#9B9B9B" stroke-width="1.75">
                <g>
                  <g>
                    <path d="M14 0L0 14M0 0L14 14"
                      transform="translate(-1190 -462) translate(695 443) translate(496 20)" />
                  </g>
                </g>
              </g>
            </g>
          </svg></span>
      </button>
    </div>
    <div class="modal-body py-0 px-0">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <p>Entire deal ( all products quantites ) will be removed.<br/> Are you sure you want to proceed?</p>
                </div>
                <div class="button-div text-center mt-3">
                    <button class="common-button mr-3" (click)="onPromotionRemovalCancel(modalService.config.initialState)">Cancel</button>
                    <button class="common-button ghost" (click)="removeDeal(modalService.config.initialState,true)">Yes, Remove</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>

